/** 与 apps/fustar `constants.ts` 及 blendviewer-hub 对齐 */
export const CLOUD_API_URL =
  import.meta.env.VITE_CLOUD_API_URL?.trim() ||
  import.meta.env.VITE_API_URL?.trim() ||
  'https://cloud-api.blendviewer.com';

export const PROJECT_ID =
  import.meta.env.VITE_BLENDVIEWER_PROJECT_ID?.trim() ||
  import.meta.env.VITE_PROJECT_ID?.trim() ||
  '6647b810-2c2e-11f1-b511-4b435a8bc2fa';

export const CLIENT_ID =
  import.meta.env.VITE_CLIENT_ID?.trim() || PROJECT_ID;
